import Vue from "vue";
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPauseCircle, faExclamationCircle, faCheckCircle, faAngleDown, faStar, faGlobe, faMapMarkerAlt, faTicketAlt, faEnvelope, faPhone, faEdit, faRocket, faUser, faUserAlt, faChair, faPhoneVolume, faHeartbeat } from '@fortawesome/free-solid-svg-icons'
import { faLinkedinIn, faInstagram, faFacebookF, faTwitter } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faPauseCircle, faExclamationCircle, faCheckCircle, faAngleDown, faStar, faGlobe, faMapMarkerAlt, faTicketAlt, faEnvelope, faPhone, faEdit, faRocket, faUser, faUserAlt, faChair, faPhoneVolume, faHeartbeat);
library.add(faLinkedinIn, faInstagram, faFacebookF, faTwitter);

Vue.component('fa-icon', FontAwesomeIcon)